import { hasXSSCharacters, isEmail, isFullNameValid } from "../helpers/Utils";
import IBaseStepModel from "./interfaces/BaseStepModel.interface";

export interface IInvoiceDetails extends IBaseStepModel {
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;

    country: string;
    county: string;
    city: string;
    postcode: string;

    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
}

export class InvoiceDetailsModel implements IInvoiceDetails {
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;

    country: string;
    county: string;
    city: string;
    postcode: string;

    addressLine1: string;
    addressLine2: string;
    addressLine3: string;

    isDirty: boolean;

    constructor() {
        this.fullName = "";
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.companyName = "";

        this.country = "";
        this.county = "";
        this.city = "";
        this.postcode = "";

        this.addressLine1 = "";
        this.addressLine2 = "";
        this.addressLine3 = "";
    }

    static validateModel = (model: IInvoiceDetails): boolean => {
        if (!model) {
            return false;
        }

        if (!model.email) {
            return false;
        }

        if (!isEmail(model.email)) {
            return false;
        }

        // in case old version of invoice component is used (for example in regift page)
        if (!model.fullName || !model.fullName.trim()) {
            if (model.firstName && model.firstName.trim() &&
                model.lastName && model.lastName.trim()) {
                model.fullName = `${model.firstName} ${model.lastName}`;
            }
        }

        if (!model.fullName || !model.fullName.trim() ||
            //!model.companyName || !model.companyName.trim() ||
            !model.country || !model.country.trim() ||
            !model.city || !model.city.trim() ||
            !model.addressLine1 || !model.addressLine1.trim()
        ) {
            return false;
        }

        if (model.postcode && model.postcode.trim() && model.postcode.trim().length < 3) {
            return false;
        }

        if (hasXSSCharacters(model.fullName) ||
            hasXSSCharacters(model.companyName) ||
            hasXSSCharacters(model.country) ||
            hasXSSCharacters(model.county) ||
            hasXSSCharacters(model.city) ||
            hasXSSCharacters(model.postcode) ||
            hasXSSCharacters(model.addressLine1) ||
            hasXSSCharacters(model.addressLine2) ||
            hasXSSCharacters(model.addressLine3)
        ) {
            return false;
        }

        if (!isFullNameValid(model.fullName)) {
            return false;
        }

        return true;
    }
}